module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.6 308"><circle class="st0" cx="231.8" cy="45.1" r="42.3"/><circle class="st0" cx="231.8" cy="263.4" r="42.3"/><circle class="st0" cx="44.9" cy="154.9" r="42.3"/><path class="st0" d="M66.7 183.01l13.35-23.123 156.4 90.3-13.35 23.123zm-10.876-51.273l156.4-90.3 13.35 23.123-156.4 90.3z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/result/ico-share.svg
// module id = 453
// module chunks = 1